import isNewestOnBottom from 'owa-mail-store/lib/utils/isNewestOnBottom';
import getConversationReadingPaneViewState from '../utils/getConversationReadingPaneViewState';
import mailStore from 'owa-mail-store/lib/store/Store';
import truncateCountForDataPointAggregation from 'owa-mail-store/lib/utils/truncateCountForDataPointAggregation';
import { isMeetingMessage } from 'owa-meeting-message-utils';
import type Item from 'owa-service/lib/contract/Item';
import type Message from 'owa-service/lib/contract/Message';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isSMIMEItem from 'owa-smime/lib/utils/isSMIMEItem';
import type { LoadConversationItemActionSource } from 'owa-mail-store';
import type { CustomData } from 'owa-analytics-types';

const MEETING_MESSAGE_CATEGORY = 'Meeting';
const MESSAGE_CATEGORY = 'Message';

export function getConversationReadingPaneStateCustomData(
    conversationId: string,
    cacheState: string,
    isPrefetchHit: boolean,
    openedCount: number,
    actionSource: LoadConversationItemActionSource
): CustomData {
    let unreadCount = 0;
    let draftCount = 0;
    let calendarCount = 0;
    let expandedCount = 0;
    let itemPartsCount = 0;
    const conversationReadingPaneViewState = getConversationReadingPaneViewState(conversationId);
    if (conversationReadingPaneViewState) {
        const itemPartsMap = conversationReadingPaneViewState.itemPartsMap;
        itemPartsMap.forEach(itemPart => {
            if (itemPart.isExpanded) {
                expandedCount++;
            }
            const message = mailStore().items.get(itemPart.itemId) as Message;
            if (message) {
                if (!message.IsRead) {
                    unreadCount++;
                }
                if (message.IsDraft) {
                    draftCount++;
                }
                if (isMeetingMessage(message)) {
                    calendarCount++;
                }
            }
        });
        itemPartsCount = itemPartsMap.size;
    }

    return {
        owa_1: getReadingPanePosition(),
        owa_2: isNewestOnBottom(),
        owa_3: truncateCountForDataPointAggregation(itemPartsCount),
        owa_4: truncateCountForDataPointAggregation(expandedCount),
        owa_5: truncateCountForDataPointAggregation(unreadCount),
        owa_6: truncateCountForDataPointAggregation(calendarCount),
        owa_7: truncateCountForDataPointAggregation(draftCount),
        owa_8: cacheState,
        owa_9: isPrefetchHit,
        owa_10: openedCount,
        owa_11: actionSource,
    };
}

export function getItemReadingPaneStateCustomData(
    item: Item,
    isPreviewPane: boolean,
    isPrint: boolean
): {
    owa_1: number;
    owa_2: string;
    owa_3: boolean;
    owa_4: boolean;
    owa_5: boolean;
} {
    return {
        owa_1: getReadingPanePosition(),
        owa_2: getItemCategory(item),
        owa_3: isPreviewPane,
        owa_4: isPrint,
        owa_5: isSMIMEItem(item),
    };
}

function getItemCategory(item: Item): string {
    // Items of type appointment, contact, DL, or task are unsupported and will therefore load the
    // unsupportedReadingPane and NOT call logItemReadingPaneStateDatapoint.

    if (isMeetingMessage(item)) {
        return MEETING_MESSAGE_CATEGORY;
    }

    return MESSAGE_CATEGORY;
}

function getReadingPanePosition(): number {
    const userConfiguration = getUserConfiguration();
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (88,5): Type 'RecursiveReadOnly<number | undefined>' is not assignable to type 'number'.
    // @ts-expect-error
    return userConfiguration.UserOptions.GlobalReadingPanePositionReact;
}
